var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9603 5.04016C22.8003 8.89216 22.8003 15.1082 18.9603 18.9602C17.1135 20.8044 14.6103 21.8403 12.0003 21.8403C9.39036 21.8403 6.88709 20.8044 5.04032 18.9602C3.19605 17.1134 2.16016 14.6101 2.16016 12.0002C2.16016 9.39019 3.19605 6.88693 5.04032 5.04016C8.89232 1.20016 15.1083 1.20016 18.9603 5.04016ZM13.8003 18.6002V13.8002H18.6003V10.2002H13.8003V5.40016H10.2003V10.2002H5.40032V13.8002H10.2003V18.6002H13.8003Z",
    fill: "#77838F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashicons);
export default __webpack_public_path__ + "static/media/dashicons.8317f9487acfcbbcc4bc258130469914.svg";
export { ForwardRef as ReactComponent };